/*
*
* File JS componente Slider List Yacht
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

Swiper.use([Navigation, Pagination, A11y]);

//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './slider-list-yacht.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const sliderListYacht = () => {
    let slider = document.querySelectorAll('.slider-list-yacht .swiper-container');
    if(!slider.length) return;
    
    slider.forEach(el => {
        
        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.querySelector('.swiper-pagination');

        let args = {
            spaceBetween: 20,
            slidesPerView: 3,
            speed: 600,
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                type: 'progressbar',
                clickable: true,
            },
            breakpoints: {
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                  loop: false,
                },
              },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(el, args);
    })
}


export default sliderListYacht;

//--------------------------------------------------------------------//